/** TanStack Query keys for teacher offline modules. */
export const queryKeys = {
  classStudents: (classId) => ["classStudents", String(classId)],
  classMeta: (classId) => ["classMeta", String(classId)],
  attendanceSubmissions: (teacherId, recordsScope = "current") =>
    ["attendanceSubmissions", String(teacherId), String(recordsScope)],
  marksSubmissions: (teacherId, recordsScope = "current") =>
    ["marksSubmissions", String(teacherId), String(recordsScope)],
  schoolNotices: (schoolId) => ["schoolNotices", String(schoolId)],
  outboxCount: ["outboxCount"],
};

export function cacheKeyForQueryKey(queryKey) {
  return `rq:${JSON.stringify(queryKey)}`;
}
